import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogOptionsDropdownContentWireframe from '../../../VeltCommentDialogOptionsDropdownContentWireframe/VeltCommentDialogOptionsDropdownContentWireframe';
import VeltCommentDialogOptionsDropdownTriggerWireframe from '../../../VeltCommentDialogOptionsDropdownTriggerWireframe/VeltCommentDialogOptionsDropdownTriggerWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
;
var VeltCommentDialogThreadCardOptions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-options-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardOptions.Content = VeltCommentDialogOptionsDropdownContentWireframe;
VeltCommentDialogThreadCardOptions.Trigger = VeltCommentDialogOptionsDropdownTriggerWireframe;
export default VeltCommentDialogThreadCardOptions;
